export default "__VITE_ASSET__924b1225__"